import type { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";
import { monitorSettingsService } from "./service";

type ICreateInsuranceCoverageMonitorSettingsRequest =
  insuranceMonitorSettingsApiSpec.CreateInsuranceCoverageMonitorSettingsRequest;
type IInsuranceCoverageMonitorSettings =
  insuranceMonitorSettingsApiSpec.InsuranceCoverageMonitorSettings;

export const createMonitorSettings = async (
  request: ICreateInsuranceCoverageMonitorSettingsRequest
): Promise<IInsuranceCoverageMonitorSettings> => {
  const { data } =
    await monitorSettingsService.post<IInsuranceCoverageMonitorSettings>(
      `/`,
      request
    );

  return data;
};
